//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    paymentSectionData: {
      type: Object,
      default: () => ({
        topCaption: {
          path: 'PAYMENT_TOP_CAPTION',
          innerText: [
            { name: 'PAYMENT_INFO_LINK_RP', title: 'PAYMENT_INFO_LINK_RP_TITLE', link: 'URL_REFUND_POLICY' },
            { name: 'PAYMENT_INFO_LINK_SR', link: 'URL_SYSTEM_REQUIREMENTS', title: 'PAYMENT_INFO_LINK_SR_TITLE' },
            { name: 'PAYMENT_INFO_LINK_EULA', link: 'URL_LICENSING', title: 'PAYMENT_INFO_LINK_EULA_TITLE' },
            { name: 'PAYMENT_INFO_LINK_FAQ', link: 'URL_FAQ', title: 'PAYMENT_INFO_LINK_FAQ_TITLE' },
          ],
        },
        mainTextHeading: 'PAYMENT_MAIN_TEXT_HEADING',
        mainTextRefund: 'PAYMENT_MAIN_TEXT_REFUND',
        mainTextBottom: {
          isExternal: true,
          name: 'PAYMENT_MAIN_TEXT_BOTTOM',
          title: 'PAYMENT_MAIN_TEXT_BOTTOM',
          link: 'URL_REFUND_POLICY',
        },
        mainText: 'PAYMENT_MAIN_TEXT',
        cardsIcons: [
          { name: 'visa', title: 'ICON_VISA_TITLE' },
          { name: 'american-express', title: 'ICON_AMERICAN_EXPRESS_TITLE' },
          { name: 'master-card', title: 'ICON_MASTER_CARD_TITLE' },
          { name: 'discover-network', title: 'ICON_DISCOVER_NETWORK_TITLE' },
          { name: 'wire-transfer', title: 'ICON_WIRE_TRANSFER_TITLE' },
          { name: 'purchase-order', title: 'ICON_PURCHASE_ORDER_TITLE' },
          { name: 'money-order', title: 'ICON_MONEY_ORDER_TITLE' },
          { name: 'check', title: 'ICON_CHECK_TITLE' },
          { name: 'pay-pal', title: 'ICON_PAYPAL_TITLE' },
          { name: 'pay-later', title: 'ICON_PAY_LATER_TITLE' },
        ],
        microsoftGoldIcon: {
          isExternal: true,
          link: 'https://www.microsoft.com/en-US/solution-providers/home',
          name: 'payment/microsoft-gold',
          title: 'ICON_MICROSOFT_GOLD_CERTIFIED_TITLE',
        },
        moneyBacGuaranteekIcon: {
          isExternal: true,
          link: 'URL_REFUND_POLICY',
          name: 'payment/money-back-guarantee',
          title: 'ICON_MONEY_BACK_GUARANTEE_TITLE',
        },
        moneyBackIcon: { name: 'payment/money-back', title: 'ICON_MONEY_BACK_TITLE' },
      }),
    },
  },
}
